document.addEventListener("DOMContentLoaded", function () {
  const leftCurtain = document.querySelector('.curtain.left');
  const rightCurtain = document.querySelector('.curtain.right');

  setTimeout(() => {
    leftCurtain.classList.add('open');
    rightCurtain.classList.add('open');
  }, 500); // Adjust delay as needed

  // Optional: Remove from DOM after animation
  setTimeout(() => {
    document.getElementById('curtain-intro')?.remove();
  }, 2000); // Matches the transition time + delay
});